module.exports = __webpack_public_path__ + "static/media/am115_pharmacology.4ee03c97.png";